
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

const init = () => {

    if (document.querySelector('.section__process') === null || window.window.innerWidth < 768) return;

    console.log('process');

    const aboutTl = gsap.timeline({
        scrollTrigger: {
            trigger: '.section__process',
            start: "top bottom",
            toggleActions: "restart none none reverse",
            end: "bottom top",
            scrub: 1
        }
    });

    const xTo = window.innerWidth - document.querySelector('.process__wrapper').offsetWidth;
    const items = document.querySelectorAll('.process__panel');

    aboutTl
    .to('.section__process .process', { top: 0, duration: 1, ease: "none" })
    .addLabel('startSlider')
    .to('.process__wrapper', { x: `${xTo}px`, duration: `${(items.length * 1)}`, ease: "sine.inOut" })
    .fromTo('.process__panel .line', { width: 0 }, { width: '100%', duration: 1.5, stagger: 1.5, ease: "none" }, 'startSlider')
    .from('.process__panel .number', { opacity: 0, duration: .5, stagger: 1.5, ease: "none" }, 'startSlider')
    .from('.process__panel .process__content', { opacity: 0, y: '50px', duration: 0.5, stagger: 1.5, ease: "quart.Out" }, 'startSlider')    
    .to('.section__process .process', { top: '-100%', duration: 1 })
    ;

};

export default { init };